<template>
  <tr>
    <td>
      <a
        :href="folderUrl"
        v-html="title"
      />
    </td>
    <td v-html="modified" />
    <td v-can="'edit-documents'">
      <a
        v-if="visibilities >= 1"
        :href="editVisibilitiesUrl"
        v-html="visibilities"
      />
      <span
        v-else
        v-html="visibilities"
      />
    </td>
    <td />
    <td v-can="'edit-documents'">
      <FolderActions
        v-if="showActions"
        :folder="folder"
      />
    </td>
  </tr>
</template>

<script type="text/babel">
import FolderActions from './SharedFolderActions'
import FileIcons from '../mixins/FileIcons'

export default {
  name: 'SharedFolderRow',
  components: {
    FolderActions,
  },
  mixins: [FileIcons],
  props: {
    folder: {
      type: Object,
      required: true,
    },
    showActions: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    folderUrl() {
      return this.$urlGenerator.active(`documents/shares/folders/${this.folder.uuid}`)
    },
    title() {
      return this.folder.attributes.title
    },
    modified() {
      return this.$date.toMomentDateFormat(this.folder.attributes.created_at)
    },
    visibilities() {
      return this.folder.attributes.visibilities
    },
    shares() {
      return this.folder.attributes.shared_count
    },
    editVisibilitiesUrl() {
      return this.$urlGenerator.active(`documents/shares/folders/${this.folder.uuid}/visibilities`)
    },
  },
  methods: {
    openEditVisibilitiesModal() {
      this.$store.commit('documentOpenEditVisibilitiesModal', this.folder)
    },
  },
}
</script>
